export default __webpack_public_path__ + "static/media/65t.4d088ce6.jpg";